<template>
  <h2
    :data-size="size"
    v-html="text"
  />
</template>

<script>
export default {
  name: 'Paragraph',

  props: {
    size: {
      type: String,
      required: false,
      default: 'normal'
    },

    text: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
h2 {
  &[data-size="small"] {
    font-family: $font-family-base;
    font-weight: 400;
    @include fluid-type(375px, 1920px, 24px, 65px, 30px, 60px);
  }

  &[data-size="team"] {
    font-family: $font-family-base;
    font-weight: 400;
    @include fluid-type(375px, 1920px, 28px, 90px, 38px, 120px);
  }

  &[data-size="normal"] {
    font-family: $font-family-base;
    font-weight: 400;
    @include fluid-type(375px, 1920px, 36px, 140px, 40px, 130px);
  }

  &[data-size="big"] {
    @include fluid-type(375px, 1920px, 38px, 100px, 48px, 120px);
    text-transform: uppercase;
  }
}
</style>
